<template>
  <div class="talk-theme-create">
    <div v-show="!isDecided">
      <!-- あなたの現在のお題は「{{ nowTheme }}」です。 -->
      <div class="form-group">
        <input class="form-control" type="text" id="talk_theme_input" placeholder="お題を入力してください。" v-model="nowTheme">
      </div>
      <!-- <button type="button" name="button" class="btn btn-danger" @click="createTheme">変更</button> -->
      <button type="button" name="button" class="btn btn-primary" @click="decideTheme">決定</button>
    </div>
    <div class="" v-show="isDecided">
      あなたのお題は「{{ nowTheme }}」です。
    </div>
  </div>
</template>
<script>
import firebase from 'firebase'

export default {
  name: 'TalkThemeCreate',
  props: {
    room_id: { type: String },
    user: null
  },
  data() {
    return {
      db: null,
      nowTheme: null,
      // nowTheme: null,
      isDecided: false
    }
  },
  methods: {
    createTheme() {
      if (this.nowTheme === null) return;

      const objectKey = "themes." + this.user.uid;
      this.db.collection('rooms').doc(this.room_id).update({
        [objectKey]: this.nowTheme
      });
      // .then(() => {
      //   this.nowTheme = this.nowTheme;
      //   this.nowTheme = null;
      // });
    },
    decideTheme() {
      if (this.nowTheme === null) return;

      this.createTheme();

      const objectKey = "isDecidedTheme." + this.user.uid;
      this.db.collection('rooms').doc(this.room_id).update({
        [objectKey]: true
      }).then(()=>{
        this.isDecided = true;
      });
    }
  },
  created() {
    this.db = firebase.firestore();
    this.isDecided = false;
    this.db.collection('rooms').doc(this.room_id).get().then(doc=>{
      this.nowTheme = doc.data().themes[this.user.uid];
    });
  }
}
</script>
<style scoped>
</style>
